import AppHeader from "@/components/AppHeader";
import dayjs from "dayjs";

export default {
  name: "attendace-user-detail",
  components: {
    AppHeader,
  },
  created() {
    this.getAttendanceUserDetail();
  },
  data() {
    return {
      selectedMonth: "",
      user: "",
      paidLeaveDay: "",
      gotYukyu: "",
      targetDates: [],
      attendances: "",
      getAttendanceUserDetailEnd: false,
      getAttendanceDetailEnd: false,
      totalSyukkinNissu: 0,
      totalHeijituZangyo: 0,
      totalHeijituShinya: 0,
      totalKyujituZangyo: 0,
      totalKyujituShinya: 0,
      totalSyoteinaiShinya: 0,
      totalZangyoGokei: 0,
      totalFurikyu: 0,
      totalTokkyu: 0,
      totalYukyu: 0,
      totalKekkin: 0,
      totalTaizaiJikan: 0,
      savingFlag: false,
      firstFlag: 1,
      requestReason: "",
      isForceApproval: "",
    };
  },
  beforeRouteLeave(to, from, next) {
    if (
      to.name === "attendance" ||
      to.name === "attendance_user_detail" ||
      to.name === "attendance_date_detail"
    ) {
      const savedata = {
        companyId: this.user.company_id,
        departmentId: this.user.department_id,
        selectedMonth: this.selectedMonth,
      };
      window.sessionStorage.setItem(
        "attendance_search",
        JSON.stringify(savedata)
      );
    } else {
      window.sessionStorage.removeItem("attendance_search");
    }
    next();
  },
  computed: {
    formatSelectedMonth() {
      return dayjs(this.selectedMonth).format("YYYY年MM月");
    },
  },
  methods: {
    async getAttendanceUserDetail() {
      this.getAttendanceUserDetailEnd = false;
      let data = {
        user_id: this.$route.params.user_id,
      };
      let res = await this.$store
        .dispatch("SHOW_ATTENDANCE_USER_DETAIL", { data: data })
        .catch((err) => {
          console.log(err);
          return;
        });
      this.user = res.user;
      if (this.firstFlag == 1) {
        this.paidLeaveDay = dayjs(`${res.paid_leave_day}`).format(
          "YYYY年MM月DD日"
        );
        this.gotYukyu = res.got_yukyu;
        if (this.user.company_id == 1) {
          let targetYyyyMm = dayjs("2020-04").format("YYYY-MM");
          let endYyyyMm = dayjs().format("YYYY-MM");
          for (;;) {
            if (targetYyyyMm > endYyyyMm) break;
            this.targetDates.unshift({
              text: dayjs(targetYyyyMm).format("YYYY年MM月"),
              value: dayjs(targetYyyyMm).format("YYYY-MM"),
            });
            this.selectedMonth = dayjs(targetYyyyMm).format("YYYY-MM");
            targetYyyyMm = dayjs(targetYyyyMm)
              .add(1, "month")
              .format("YYYY-MM");
          }
        } else {
          let today = new Date();
          let targetYyyyMm = dayjs("2020-04").format("YYYY-MM");
          let endYyyyMm = dayjs().format("YYYY-MM");
          if (today.getDate() >= 16) {
            endYyyyMm = dayjs()
              .add(1, "month")
              .format("YYYY-MM");
          }
          for (;;) {
            if (
              targetYyyyMm > endYyyyMm
              //  ||
              // (targetYyyyMm == endYyyyMm && today.getDate() < 16)
            )
              break;
            this.targetDates.unshift({
              text: dayjs(targetYyyyMm).format("YYYY年MM月"),
              value: dayjs(targetYyyyMm).format("YYYY-MM"),
            });
            this.selectedMonth = dayjs(targetYyyyMm).format("YYYY-MM");
            targetYyyyMm = dayjs(targetYyyyMm)
              .add(1, "month")
              .format("YYYY-MM");
          }
        }
        this.firstFlag = 0;
      }
      if (window.sessionStorage.getItem("attendance_search")) {
        const data = JSON.parse(
          window.sessionStorage.getItem("attendance_search")
        );
        this.selectedMonth = data.selectedMonth;
      }
      this.getAttendanceUserDetailEnd = true;
      this.getAttendanceDetail();
    },
    async getAttendanceDetail() {
      this.getAttendanceDetailEnd = false;
      let data = {
        user_id: this.$route.params.user_id,
        target_month: this.selectedMonth,
      };
      let res = await this.$store
        .dispatch("SHOW_ATTENDANCE_DETAIL", { data: data })
        .catch((err) => {
          console.log(err);
          return;
        });
      this.attendances = res.attendances;

      this.totalSyukkinNissu = 0;
      this.totalHeijituZangyo = 0;
      this.totalHeijituShinya = 0;
      this.totalKyujituZangyo = 0;
      this.totalKyujituShinya = 0;
      this.totalSyoteinaiShinya = 0;
      this.totalZangyoGokei = 0;
      this.totalFurikyu = 0;
      this.totalTokkyu = 0;
      this.totalYukyu = 0;
      this.totalKekkin = 0;
      this.totalTaizaiJikan = 0;
      for (let i = 0; i < this.attendances.length; i++) {
        if (
          (this.attendances[i].detail.attendance_type == "work" ||
            this.attendances[i].detail.attendance_type == "half_day_leave") &&
          this.attendances[i].detail.attendance_status == "approvaled"
        ) {
          this.totalSyukkinNissu += 1;
        }
        this.totalHeijituZangyo += this.attendances[i].detail.heijitu_zangyo;
        this.totalHeijituShinya += this.attendances[i].detail.heijitu_shinya;
        this.totalKyujituZangyo += this.attendances[i].detail.kyujitu_zangyo;
        this.totalKyujituShinya += this.attendances[i].detail.kyujitu_shinya;
        this.totalSyoteinaiShinya += this.attendances[
          i
        ].detail.syoteinai_shinya;
        this.totalZangyoGokei += this.attendances[i].detail.zangyo_gokei;
        this.totalFurikyu += this.attendances[i].detail.furikyu;
        this.totalTokkyu += this.attendances[i].detail.tokkyu;
        this.totalYukyu += this.attendances[i].detail.yukyu;
        this.totalKekkin += this.attendances[i].detail.kekkin;
        this.totalTaizaiJikan += this.attendances[i].detail.roudou_jikan;
        this.totalTaizaiJikan += this.attendances[i].detail.kyukei_jikan;
      }

      this.getAttendanceDetailEnd = true;
    },
    async outputDailyReportPdf() {
      let data = {
        company_id: this.user.company_id,
        department_id: this.user.department_id,
        user_id: this.user.id,
        selected_month: this.selectedMonth,
      };
      let res = await this.$store
        .dispatch("PDF_DAILY_REPORT", { data: data })
        .catch((err) => {
          console.log(err);
          return;
        });
      let link = document.createElement("a");
      let pdfFileName =
        "作業日報" +
        this.selectedMonth +
        this.user.last_name +
        this.user.first_name +
        ".pdf";
      let bom = new Uint8Array([0xef, 0xbb, 0xbf]);

      const blob = new Blob([bom, res], { type: "application/pdf" });

      link.style = "display: none";
      link.download = pdfFileName;
      link.target = "_blank";

      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, pdfFileName);
      } else if (window.URL && window.URL.createObjectURL) {
        link.href = window.URL.createObjectURL(blob);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else if (window.webkitURL && window.webkitURL.createObject) {
        link.href = (window.URL || window.webkitURL).createObjectURL(blob);
        link.click();
      }
    },
    dateFormat(date) {
      return dayjs(date).format("MM月DD日");
    },
    weekType(attendance) {
      if (attendance.youbi == "日") {
        return "text-danger";
      } else if (attendance.is_holiday == 1) {
        return "text-primary";
      }
    },
    bgClass(attendance) {
      if (attendance.youbi == "日") {
        return "bg-palered";
      } else if (attendance.is_holiday == 1) {
        return "bg-paleblue";
      }
    },
    isApprovaled(attendanceStatus) {
      if (attendanceStatus == "approvaled") {
        return true;
      } else {
        return false;
      }
    },
    isNotAttendance(detail) {
      if (detail.attendance_type == "") {
        return false;
      } else {
        return true;
      }
    },
    goAttendanceDateDetail(date) {
      this.$router.push({
        path: `/attendance/${this.$route.params.user_id}/user/${date}`,
      });
    },
    async UpdateAllApprovaled() {
      if (this.savingFlag) return;
      this.savingFlag = true;

      let data = {
        user_id: this.$route.params.user_id,
        target_month: this.selectedMonth,
      };
      await this.$store
        .dispatch("UPDATE_ALL_APPROVALED", { data: data })
        .catch((err) => {
          console.log(err);
          return;
        });
      this.getAttendanceUserDetail();
      this.savingFlag = false;
    },
    async checkLeave(date) {
      this.isForceApproval = "";
      let data = {
        leave_date: date,
        user_id: this.$route.params.user_id,
      };
      let res = await this.$store
        .dispatch("CHECK_LEAVE_REASON", { data: data })
        .catch((err) => {
          console.log(err);
          return;
        });
      if (res.approval_leave.discarded_at) {
        this.isForceApproval = "※強制承認されています";
      }
      this.requestReason = res.approval_leave.request_reason;
      this.$bvModal.show("modal-leave");
    },
  },
};
